// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/widget-page-observation.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { widgetPageObservationsApi } from "../../api/widget-page-observations";
import type { WidgetPageObservation } from "../../api/types";
// override-block:imports BEGIN
// CHG-2471 / ITER-905213 — Widget Studio S5. page_type renders as a chip
// (`chip` is not a built-in cell type → custom column + render helper).
import type { ReactNode } from "react";
import { chipCell } from "../../lib/widget-cells";
// override-block:imports END

// override-block:helpers BEGIN
function pageTypeColumn(row: WidgetPageObservation): ReactNode {
  return chipCell(row.page_type);
}
// override-block:helpers END

export const widgetPageObservationListConfig: ListPageConfig<WidgetPageObservation> = {
  title: "Page observations",
  subtitle: "Per-page telemetry for where your widgets render (append-only; no edits).",
  queryKey: ["widget-page-observations", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search, filters }) =>
    widgetPageObservationsApi.listWidgetPageObservations({ page, pageSize, sortField, sortDirection, search, filters }),
  defaultSort: { field: "last_seen_at", direction: "desc" },
  pageSize: 50,
  rowHref: "/widget-page-observations/{id}",
  search: { enabled: true, placeholder: "Search observations by URL pattern…" },
  emptyState: {
    title: "No page observations yet",
    subtitle: "Observations accumulate as your widgets render across pages.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // override-block:header-actions END
  ],
  filters: [
    { field: "widget_instance_id", label: "Widget", type: "entity-search", targetEntity: "widget-instance" },
  ],
  columns: [
    { field: "domain", label: "Domain", type: "text", sortable: true },
    { field: "page_type", label: "Page type", type: "custom", render: pageTypeColumn },
    { field: "url_pattern", label: "URL pattern", type: "text" },
    { field: "render_count", label: "Renders", type: "number", sortable: true },
    { field: "impression_count", label: "Impressions", type: "number", sortable: true },
    { field: "click_count", label: "Clicks", type: "number", sortable: true },
    { field: "last_seen_at", label: "Last seen", type: "datetime", sortable: true },
  ],
};
